/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SITE_WOWCHER, SITE_WOWCHERIE } from '../../config/setup/setup';
import { MINI_MENU_LABEL_MERCHANT_AREA, LOGOUT } from '../../config/text/text';
import { hashCode } from '../../helpers/hash';
import { Logout } from '../../helpers/logout';
import ThemeContext from '../../providers/ThemeProvider';
import useToast from '../_generic/toast/UseToast';

const AccountOptions = ({
  options,
  accountOptionsLower,
  merchant,
  site = SITE_WOWCHER,
}) => {
  const theme = useContext(ThemeContext);
  const toast = useToast();
  const dispatch = useDispatch();
  const isVipUser = useSelector((state) => state.user.userprofile.vipUser);
  const [merchantURL] = useSelector((state) => [state.merchant]);

  let displayOptions = options;
  if (!isVipUser) {
    displayOptions = displayOptions.filter((option) => !option.isVipOnly);
  }

  if ((site === SITE_WOWCHER || site === SITE_WOWCHERIE) && merchant) {
    displayOptions.pop();
    displayOptions.push({
      name: MINI_MENU_LABEL_MERCHANT_AREA,
      value: merchantURL?.url,
    });
  }

  const logoutAction = async (event) => {
    event.preventDefault();
    Logout(event, toast, dispatch);
  };

  return (
    <>
      <ul
        className={classNames('account-options__list', {
          'text-lowercase': site !== SITE_WOWCHER && site !== SITE_WOWCHERIE,
        })}
      >
        {displayOptions.map((item, index) => (
          <li key={`account-options--${hashCode()}-${index}`}>
            <Link href={item.value ?? ''}>
              <a className="account-options__link">{item.name}</a>
            </Link>
          </li>
        ))}
      </ul>
      <hr />
      <ul
        className={classNames('account-options__list', {
          'text-lowercase': site !== SITE_WOWCHER && site !== SITE_WOWCHERIE,
        })}
      >
        {accountOptionsLower.map((item, index) => (
          <li key={`account-options-lower--${hashCode()}-${index}`}>
            <Link href={item.value ?? ''}>
              <a className="account-options__link">{item.name}</a>
            </Link>
          </li>
        ))}
        <li>
          <Link href="#">
            <a
              className="account-options__link"
              onClick={logoutAction}
              onKeyDown={logoutAction}
              role="link"
              tabIndex={0}
            >
              {LOGOUT}
            </a>
          </Link>
        </li>
      </ul>
      <style jsx>{`
        .account-options__list {
          list-style: none;
          padding: 0;
        }
        .account-options__list:last-child {
          margin-bottom: 0;
        }
        .account-options__link {
          color: ${theme.colors.primary};
          text-decoration: none;
        }
        .account-options__link:hover {
          color: ${theme.colors.linkhover};
        }

        hr {
          margin: 15px 0;
          border-color: #e6e6e6;
          border: none;
          border-top: 1px solid #e6e6e6;
          height: 0;
        }
      `}</style>
    </>
  );
};

AccountOptions.propTypes = {
  accountOptionsLower: PropTypes.array.isRequired,
  merchant: PropTypes.bool,
  options: PropTypes.array.isRequired,
  site: PropTypes.string,
};

export default AccountOptions;
